























import Vue from 'vue'
import store from '../store'
import { getDecks } from '../assets/utility'
import { DeckInfo } from '../models'
import { firestore } from 'firebase'
import Decks from './Library/Decks.vue'
import Cards from './Library/Cards.vue'
import GoToButton from '../components/Buttons/GoToButton.vue'
import LoginModal from './Modals/LoginModal.vue'
import Logout from './Logout.vue'
require('typeface-lobster')
export default Vue.extend({
  name: 'Library',
  components: {
    Decks,
    Cards,
    GoToButton,
    Logout,
    LoginModal
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  computed: {
    askLogin () {
      return store.state.askLogin
    }
  },
  methods: {
    showLogin () {
      this.$modal.show('login')
    }
  }
})

